import { createAsyncAction } from 'typesafe-actions'
import {
  GetGeneralSettingsResponseDto,
  UpdateGeneralCommissionSettingsRequestDto,
  UpdateGeneralCommissionSettingsResponseDto,
} from '@sparling/financial-common'

export const {
  request: getGeneralSettingsRequest,
  success: getGeneralSettingsSuccess,
  failure: getGeneralSettingsFailure,
} = createAsyncAction('GET_GENERAL_SETTINGS_REQUEST', 'GET_GENERAL_SETTINGS_SUCCESS', 'GET_GENERAL_SETTINGS_FAILURE')<
  undefined,
  GetGeneralSettingsResponseDto,
  Error
>()

export const {
  request: updateGeneralCommissionSettingsRequest,
  success: updateGeneralCommissionSettingsSuccess,
  failure: updateGeneralCommissionSettingsFailure,
} = createAsyncAction(
  'UPDATE_GENERAL_COMMISSION_SETTINGS_REQUEST',
  'UPDATE_GENERAL_COMMISSION_SETTINGS_SUCCESS',
  'UPDATE_GENERAL_COMMISSION_SETTINGS_FAILURE',
)<UpdateGeneralCommissionSettingsRequestDto, UpdateGeneralCommissionSettingsResponseDto, Error>()
